import React, { useEffect, useState } from "react";
import { X, CreditCard } from "lucide-react";

const STORAGE_KEY = "peptichill_test_mode_dismissed_v1";

/**
 * Small dismissible banner above the header reminding test-mode users of the
 * Stripe test card details. Auto-hides once Stripe is in live mode.
 */
export default function TestModeBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;
    const dismissed = window.localStorage.getItem(STORAGE_KEY) === "1";
    // Show when REACT_APP_STRIPE_PUBLISHABLE_KEY is empty or starts with pk_test_,
    // OR when REACT_APP_TEST_MODE is explicitly truthy. We're in managed test
    // mode by default (no publishable key in the client), so default-on.
    const stripeKey = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || "";
    const explicitOff = stripeKey.startsWith("pk_live_");
    const explicitOn =
      (process.env.REACT_APP_TEST_MODE || "").toLowerCase() === "true" ||
      !explicitOff;
    if (explicitOn && !dismissed) setVisible(true);
  }, []);

  const dismiss = () => {
    try { window.localStorage.setItem(STORAGE_KEY, "1"); } catch { /* noop */ }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className="bg-ice border-b border-silver/40 text-navy"
      data-testid="test-mode-banner"
      role="status"
    >
      <div className="container-pc flex flex-wrap items-center justify-between gap-2 py-2">
        <p className="text-xs sm:text-[13px] flex items-center gap-2 leading-snug">
          <CreditCard size={14} className="text-cyan shrink-0" />
          <span>
            <strong className="font-semibold">Test mode</strong> — use Stripe test card{" "}
            <code className="font-mono bg-white/70 rounded px-1.5 py-0.5 text-[12px]">
              4242 4242 4242 4242
            </code>
            , any future expiry, any CVC.
          </span>
        </p>
        <button
          type="button"
          onClick={dismiss}
          aria-label="Dismiss test-mode notice"
          data-testid="test-mode-banner-dismiss"
          className="inline-flex h-7 w-7 items-center justify-center rounded-full hover:bg-white/60 transition"
        >
          <X size={14} />
        </button>
      </div>
    </div>
  );
}
